<template>
  <div class="cust-shell">
    <v-navigation-drawer
      v-model="drawer"
      class="cust-drawer"
      app
      width="260"
      :permanent="!isMobileNav"
      :temporary="isMobileNav"
    >
      <customer-drawer />
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="!isMobileNav"
      app
      flat
      class="cust-topbar"
      height="64"
    >
      <v-app-bar-nav-icon
        v-if="isMobileNav"
        color="#184679"
        class="cust-topbar-menu"
        @click.stop="toggleDrawer"
      />
      <v-spacer />
      <div class="cust-topbar-actions">
        <renewal-reminder-bell v-if="isAuthenticated" audience="customer" class="cust-topbar-bell" />
        <avatar compact />
      </div>
    </v-app-bar>

    <v-main class="cust-main">
      <v-container class="cust-main-container fill-height tw-min-h-full" fluid>
        <slot />
      </v-container>
    </v-main>
    <screen-idle :dialog="isAppIdle" />
  </div>
</template>

<script>
import CustomerDrawer from '@/components/layout/partials/CustomerDrawer';
import Avatar from '@/components/layout/partials/nav/Avatar';
import { mapGetters } from 'vuex';
import ScreenIdle from '@/components/shared/ScreenIdle';
import RenewalReminderBell from '@/components/renewals/RenewalReminderBell';

export default {
  name: 'Default',
  components: {
    ScreenIdle, Avatar, CustomerDrawer, RenewalReminderBell,
  },
  data() {
    return {
      drawer: true,
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser', 'isAuthenticated']),
    /** Tablet/phone — overlay nav + hamburger. Desktop keeps a permanent sidebar. */
    isMobileNav() {
      return this.$vuetify?.breakpoint?.mdAndDown ?? false;
    },
  },
  watch: {
    isMobileNav: {
      handler(mobile) {
        this.drawer = !mobile;
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.$store.getters['auth/isAuthenticated']) {
      this.$store.dispatch('portalCache/fetchCustomerClient');
    }
    if (this.$eventsHub) {
      this.$eventsHub.$on('customer-tour-open-drawer', this.openDrawerForTour);
    }
  },
  beforeDestroy() {
    if (this.$eventsHub) {
      this.$eventsHub.$off('customer-tour-open-drawer', this.openDrawerForTour);
    }
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    openDrawerForTour() {
      this.drawer = true;
    },
  },
};
</script>

<style src="@/assets/css/customer-shell.css"></style>
